/**
 * Joins a base URL and a path into an absolute URL,
 * collapsing duplicate slashes at the boundary.
 *
 * @param baseUrl - Base URL, with or without a trailing slash
 * @param path - Path to append, with or without a leading slash
 * @returns The joined absolute URL
 */
export function joinUrl(baseUrl: string, path: string): string {
  return `${baseUrl.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`;
}
